import React, { useState } from "react";
import ActionButton from "controls/global/action-button";
import SendMessageDocumentDialog from "./SendMessageDocumentDialog";
import { v4 as uuidv4 } from "uuid";
import SendMessageIcon from "theme/icons/SendMessageIcon";
import { gaps } from "theme/defaultStyle";

type SendMessageDocumentProps = {
  productIndex: number;
  parentIntegrationKey?: string;
  performSearchDocument?: () => Promise<void>;
  performSearch?: () => Promise<void>;
  saveFile: () => Promise<void>;
  reloadFile: () => Promise<void>;
  reloadFileActivities: () => Promise<void>;
  revising: boolean;
  disabled: boolean;
};

export const SendMessageDocument: React.FC<SendMessageDocumentProps> = ({
  productIndex,
  parentIntegrationKey,
  performSearchDocument,
  performSearch,
  saveFile,
  reloadFileActivities,
  reloadFile,
  revising,
  disabled = false,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [keys, setKeys] = useState<string>("");

  return (
    <div>
      <ActionButton
        onClick={() => {
          setKeys(uuidv4());
          setIsDialogOpen(true);
        }}
        variant="outlined"
        color="secondary"
        startIcon={<SendMessageIcon />}
        sx={{ gap: gaps.zero }}
        disabled={revising || disabled}
      >
        Send Message/Documents
      </ActionButton>

      <SendMessageDocumentDialog
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
        key={keys}
        notDisabled={true}
        productIndex={productIndex}
        parentIntegrationKey={parentIntegrationKey}
        performSearchDocument={performSearchDocument}
        performSearch={performSearch}
        saveFile={saveFile}
        reloadFile={reloadFile}
        reloadFileActivities={reloadFileActivities}
      />
    </div>
  );
};
